"use strict";
// Copyright 2019 Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty(exports, "__esModule", { value: true });
var PromisedWebSocketClosureCode;
(function (PromisedWebSocketClosureCode) {
    PromisedWebSocketClosureCode[PromisedWebSocketClosureCode["Normal"] = 1000] = "Normal";
    PromisedWebSocketClosureCode[PromisedWebSocketClosureCode["EmptyCloseFrame"] = 1005] = "EmptyCloseFrame";
})(PromisedWebSocketClosureCode = exports.PromisedWebSocketClosureCode || (exports.PromisedWebSocketClosureCode = {}));
exports.default = PromisedWebSocketClosureCode;
//# sourceMappingURL=PromisedWebSocketClosureCode.js.map